import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#232323] text-white pt-8 pb-2">
      <div className="max-w-7xl mx-auto px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          {/* About milestone Associates */}
          <div>
            <h3 className="text-2xl font-bold mb-3">About Milestone Associates</h3>
            <p className="mb-4 text-lg text-white/90">Our staff is capable to handle all capacity of MEP Design projects and supervision jobs.</p>
            <a href="https://pk.linkedin.com/in/rana-ali-haider-01398723" className="inline-flex w-12 h-12 bg-white rounded-full items-center justify-center no-underline text-2xl text-[#232323] hover:bg-gray-200 transition mb-2" title="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-7 h-7"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.785-1.75-1.75s.784-1.75 1.75-1.75 1.75.785 1.75 1.75-.784 1.75-1.75 1.75zm15.5 11.268h-3v-5.604c0-1.337-.025-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.967v5.7h-3v-10h2.881v1.367h.041c.401-.761 1.379-1.563 2.838-1.563 3.036 0 3.6 2 3.6 4.59v5.606z"/></svg>
            </a>
            <img src="/images/logo.webp" alt="Company Logo" className="mx-auto mt-2 mb-1 max-w-[220px]" />
          </div>
          {/* Quick Links 1 */}
          <div>
            <h4 className="text-xl font-bold mb-3">Quick Links</h4>
            <ul className="list-none p-0 m-0 space-y-2 text-lg">
              <li><Link to="/" className="hover:underline">Home</Link></li>
              <li><Link to="/about" className="hover:underline">About Us</Link></li>
              <li><Link to="/projects" className="hover:underline">Projects</Link></li>
            </ul>
          </div>
          {/* Quick Links 2 */}
          <div>
            <h4 className="text-xl font-bold mb-3">Quick Links</h4>
            <ul className="list-none p-0 m-0 space-y-2 text-lg">
              <li><Link to="/services" className="hover:underline">Services</Link></li>
              <li><Link to="/clients" className="hover:underline">Clients</Link></li>
              <li><Link to="/contact" className="hover:underline">Contact Us</Link></li>
            </ul>
          </div>
          {/* Contact Us */}
          <div>
            <h4 className="text-xl font-bold mb-3">Contact Us</h4>
            <div className="mb-2">
              <span className="font-bold">Location:</span><br />
              Address: Off#817, 8th Floor, Al-Hafeez Shopping Mall, Main Boulevard Gulberg, Lahore. 
            </div>
            <div className="mb-2">
              <span className="font-bold">Tel:</span><br />
              <a href="tel:+923457481530" className="hover:underline text-white/90 block">+92 345 7481530</a>
            </div>
            
            <div>
              <span className="font-bold">Email:</span><br />
              <a href="mailto:milestoneassociatesconsultants@gmail.com" className="hover:underline text-white/90 block">milestoneassociatesconsultants@gmail.com</a><br />
             
            </div>
          </div>
        </div>
        <hr className="border-white/20 mb-2" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-center pb-2">
          <p className="text-sm text-gray-500 mt-4 text-center">
  Developed by <a
    href="https://www.linkedin.com/in/muhammad-aqib-b4b164320?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    target="_blank"
    rel="noopener noreferrer"
    className="text-red-600 hover:underline font-semibold"
  >
    Aqib & Team
  </a>
</p>

          <div className="text-white/90 text-base font-medium">
            All Right Reserved © Milestone Associates (PVT) Limited
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 